import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { ExtraInfo } from '../models/extra-info.model';

@Injectable({
    providedIn: 'root'
})
export class ExtraInfoService {

    private apiURL: string;

    constructor(private http: HttpClient, private appConfigurationService: AppConfigurationService) {

        this.apiURL = this.appConfigurationService.baseApi + '/extrainfo';

    }

    get(): any {

        const url = this.apiURL;
        return this.http.get<ExtraInfo[]>(url);

    }

}
